// Посилання «Show comment» із телеграм-бота.
//
// Бот присилає <адреса>#<гілка>/<коментар>, і адресу бере ту, яку comments.app
// запамʼятав для гілки. У старих сповіщеннях там корінь сайту — людина тисне
// «Show comment» під коментарем до серії й потрапляє на головну.
//
// Ідентифікатор гілки в посиланні правильний завжди, тому розбираємо хеш самі:
// питаємо сервер, якій сторінці належить гілка, і, якщо це не та сторінка, де
// ми зараз, тихо переводимо людину куди треба разом із хешем.

// Рівно той формат, який comments.app кладе в свої посилання
const ANCHOR = /^#([A-Za-z0-9_-]{6,32})\/(\d+)$/

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', async () => {
    const hash = window.location.hash
    const match = hash.match(ANCHOR)
    if (!match) return

    let url = null
    try {
      const data = await $fetch('/api/commentThread', {
        query: { id: match[1] }
      })
      url = data?.url
    } catch (e) {
      // Не змогли дізнатись — лишаємо людину там, куди вона прийшла
    }
    if (!url) return

    // Роут віддає шлях у межах сайту — на чужий домен нас звідси не заведуть
    const target = new URL(url, window.location.origin)
    const here = window.location
    if (target.pathname === here.pathname && target.search === here.search) {
      return
    }

    // replace, а не push: кнопка «назад» має вести в телеграм, а не на головну
    await nuxtApp.$router.replace({
      path: target.pathname,
      query: Object.fromEntries(new URLSearchParams(target.search)),
      hash
    })
  })
})
